import e from"./stateManager.js";var a=new e;export{a as default,a as representativeByIdentityManager};
//# sourceMappingURL=representativeByIdentityManager.js.map